// MarketerBase.js
import React from "react";


const MarketerBaseState = {
    page1: 0,
    limit: 50,   // هر صفحه چندتا رکورد بیاد
    total: 0,    // تعداد کل رکوردها
    insuranceType: '', // thirdparty | bodily
    optionPeymentType: [],
    optionPostingType: [],
    optionVisitType: [],
    optionCompany: [],
    selectedTherapyInsurer: "",
    thirdpartyAddress: "",
    thirdpartyShippingAddress: "",
    bodycarAddress: "",
    bodycarShippingAddress: "",
    thirdpartyInsurancePrice: "",
    bodyCarInsurancePrice: "",
    selectedCompany: null,
    BodycarPaymentType: null,
    ThirdpartyPaymentType: null,
    BodycarPostingType: null,
    BodycarVisitType: null,
    ThirdpartyPostingType: null,
    selectedDayEnd: "",
    selectedDayStart: "",
    selectedDateCallback: "",
    CustomerPhoneNumber: "",
    thirdPartyInsuranceStartDate: "",
    bodyCarInsuranceStartDate: "",
    thirdPartyEndDateOfInsurance: "",
    bodyCarEndDateOfInsurance: "",
    selectedThirdpartyDateOfSubmission: "",
    selectedBodycarDateOfSubmission: "",
    selectedBodycarDateOfVisit: "",
    anchorEl: null,
    currentRowId: null,
    redirect: false,
    errstr: "",
    errstatus: false,
    okstatus: false,
    requestinfos: [],
    agentInfofilter: [],
    orderBy2: [],
    order2: [],
    agentInfofilter2: [],
    rowsPerPage: 10,
    page: 0,
    id: "",
    idrequest: "",
    accident_main_coverage_name: "",
    searchText: "",
    insurer: "",
    full_name: "",
    issued_by: "",
    typePolicy: "",
    beginDate: "",
    endDate: "",
    sms_date: "",
    excel_name: "",
    vehicalName: "",
    plateNumber: "",
    productionDate: "",
    cooperation_start_date: "",
    issue_date: "",
    string: "",
    policy_number: "",
    policyholder: "",
    relation: "",
    parent_name: "",
    phone_number: "",
    personnel_no: "",
    management_name: "",
    company_name: "",
    nationalCode: "",
    message_content: "",
    resend_sms: "",
    discountFinance: "",
    discountLife: "",
    discountDriver: "",
    lastPolicyNumber: "",
    policyNumber: "",
    policyUniqueCode: "",
    engineNumber: "",
    chassisNo: "",
    vin: "",
    call_back_desc: "",
    thirdparty_policy_number: "",
    bodycar_policy_number: "",
    thirdparty_postal_code: "",
    bodycar_postal_code: "",
    call_back_date: "",
    call_back_status: "",
    isEmployeeFilterActive: false,
    employee_id: "",
    auth_id: "",
    is_called: "",
    last_status: "",
    orderBy: "id",
    order: "desc",
    snackstr: "",
    showSnack: false,
    snackMode: "success",
    newAccidentMainCoverage: true,
    request_id: null,
    cheak_box_desc: "",
    isChecked: "false",
    thirdpartySameAddress: "true",
    bodycarSameAddress: "true",
};

export default MarketerBaseState;
